import React, { Component } from 'react';
import {connect} from 'react-redux';
import {Route, Switch} from "react-router";
import Authorization from '../containers/authorizationHOC';
import UserLayout from '../components/userLayout';
import AdminLayout from '../components/adminLayout';
import AgentLayout from '../components/agentLayout';

class RoleRouter extends Component {
  render() {
    if(this.props.loggedInUserRoles.indexOf('Administrator')>-1) {
			return (
        <Switch>
          <Route path="/" component={UserLayout}/>
        </Switch>
			)
		} else if(this.props.loggedInUserRoles.indexOf('User')>-1) {
			return (
        <Switch>
          <Route path="/" component={UserLayout}/>
        </Switch>
			)
    }
    else if(this.props.loggedInUserRoles.indexOf('Underwriter')>-1) {
        return (
            <Switch>
                <Route path="/" component={UserLayout}/>
            </Switch>
        )
    }
    else if(this.props.loggedInUserRoles.indexOf('Technical Underwriter')>-1) {
        return (
            <Switch>
                <Route path="/" component={UserLayout}/>
            </Switch>
        )
    }
    else if(this.props.loggedInUserRoles.indexOf('Medical Expert')>-1) {
        return (
            <Switch>
                <Route path="/" component={UserLayout}/>
            </Switch>
        )
    }
    else {
			return (
        <Switch>
          <Route path="/" component={AgentLayout}/>
        </Switch>
      )
    }
	}
};

const mapStateToProps = (state) => {
    return {
        loggedInUserRoles: state.user.loggedInUser.roles
    }
};

const mapDispatchToProps = (dispatch) => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleRouter);